var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-field-library",
      staticStyle: { "background-color": "rgb(255,255,255)" },
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "modal-field-title" }, [_vm._v("ICONS")]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-field-content" }, [
        _c("div", { staticClass: "input-search" }, [
          _c("i", { staticClass: "fa fa-search" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchIcon,
                expression: "searchIcon"
              }
            ],
            attrs: { type: "text", placeholder: "Search" },
            domProps: { value: _vm.searchIcon },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchIcon = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-field" }, [
          _c(
            "div",
            { staticClass: "icon-list" },
            _vm._l(_vm.icons, function(icon, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "list",
                  on: {
                    click: function($event) {
                      _vm.$emit("select-icon", icon)
                    }
                  }
                },
                [_c("img", { attrs: { src: icon.icon_grey } })]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-field-footer" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("Close")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3873c864", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3873c864","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jModalPageIcon.vue
// module id = null
// module chunks = 